import { Injectable } from '@angular/core';

import { ActivityParticipantStatus } from '@azavista/servicelib';
import { SharedService } from '../../shared.service';
import { IActivityParticipantGroupByStatusSettings, IActivityParticipantGroupByStatusSettingsRemote } from './interfaces';
import { IIdWithName } from '@azavista/components/shared';

@Injectable({
    providedIn: 'root'
})
export class ActivityParticipantGroupByStatusWidgetService {
    constructor(private readonly sharedSvc: SharedService) {
    }

    areRemoteSettingsProvided(remote: IActivityParticipantGroupByStatusSettingsRemote): boolean {
        return !!(remote && remote.activity_id && remote.event_id);
    }

    areSettingsValid(settings: IActivityParticipantGroupByStatusSettings): boolean {
        if (!settings.remote) {
            return false;
        }
        if (!settings.remote.event_id) {
            return false;
        }
        if (!settings.remote.activity_id) {
            return false;
        }
        if (!settings.remote.activity_participant_statuses || settings.remote.activity_participant_statuses.length === 0) {
            return false;
        }
        return true;
    }

    getActivityParticipantStatuses(): IIdWithName[] {
        const allStatuses = [
            ActivityParticipantStatus.new,
            ActivityParticipantStatus.waitingList,
            ActivityParticipantStatus.registered,
            ActivityParticipantStatus.arrived,
            ActivityParticipantStatus.noShow
        ];
        const statuses: IIdWithName[] = [];
        for (const status of allStatuses) {
            statuses.push({
                id: status,
                name: this.sharedSvc.translateParticipantActivityStatus(status)
            });
        }
        return statuses;
    }
}
